exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".line-container {\n  height: 300px;\n  width: 100%;\n  display: block; }\n\n.gauge-container {\n  height: 300px;\n  width: 100%;\n  display: block; }\n\n.shadow {\n  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19); }\n\n@media (min-width: 768px) and (max-width: 768px) {\n  .social-widget-card {\n    top: 21px !important; } }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /builds/yaratechnologies/talkative-parents-portal/src/app/parent/dashboard/pages/course/Selectdashboardstudent/selectdashboardstudentH.component.scss
// module id = ../../../../../src/app/parent/dashboard/pages/course/Selectdashboardstudent/selectdashboardstudentH.component.scss
// module chunks = main